import "../scss/product.scss";
import "../components/product-viewmore";
import { toggleSubscriptionInfo, toggleSubscriptionOptions } from "../components/product-subscriptions";
import { stickyCart } from "../components/sticky-cart";
import { resetAndPauseVideo, videoReviewOpen, videoReviewCarouselListener } from "../components/video-player";
// import { onClickCustomOption, onClickCustomSelects } from "../components/custom-select";
import { mainProductSwiper } from "../components/product-slider";


toggleSubscriptionOptions(
  'main :not(.modal-cart) .main-product__subscriptions-wrapper'
);
toggleSubscriptionInfo('main :not(.modal-cart) ')
stickyCart();
mainProductSwiper();

const mainProductATC = document.querySelector('#jc-mp-scroll');

if (mainProductATC ) {
  mainProductATC.addEventListener('click', (e)=>{
  e.preventDefault();

   let target = document.querySelector('#main-product__detail');
   target.scrollIntoView({ behavior: 'smooth' });
})
}

resetAndPauseVideo();
videoReviewCarouselListener();
videoReviewOpen();